<template>
  <div class="home"  @scroll="handleScroll">
    <!-- 客服在线咨询样式 -->
    <link rel="stylesheet" href="https://kefu.zhujiaxian.com/assets/css/index/ymwl_online.css">
    <!-- 二级路由坑 -->
    <router-view v-if="$route.path === '/searchPopup'"></router-view>
    <main v-else>
      <!--搜索框url('')-->
      <div
        style="
          background-image: url('https://img.zhujiaxian.com/2026/01/77e3bc3349ec4acca213067cd4bdac39.png');
          background-size: cover;
        "
      >
        <div>
        </div>
        <van-search
          shape="round"
          v-model="value"
          placeholder="请输入搜索关键词"
          @search="onSearch"
          @cancel="onCancel"
          @click="$router.push('/searchPopup')"
        />
        <!-- 推荐栏 -->
        <div class='header' style="display: flex;justify-content: space-evenly;">
          <div style="display:flex;align-items:center;">
            <img src="https://img.zhujiaxian.com/2025/12/7fdc3e939f8a47bfb486a7688d357117.png" style="width: 16.9px;height:16px;margin-right: 5px;" />
            <span style="font-size: 10px;color:#FFD1D1;">新鲜美味</span>
          </div>
          <div style="display:flex;justify-content:flex-start;align-items:center;">
            <img src="https://img.zhujiaxian.com/2025/12/e91123c97cb5411382660b482bf3bee9.png" style="width: 16.9px;height:16px;margin-right: 5px;" />
            <span style="font-size: 10px;color:#FFD1D1;">品质优选</span>
          </div>
          <div style="display:flex;justify-content:flex-start;align-items:center;">
            <img src="https://img.zhujiaxian.com/2025/12/354848b724814e0bb5b142519cb96b28.png" style="width: 16.9px;height:16px;margin-right: 5px;" />
            <span style="font-size: 10px;color:#FFD1D1;">急速送达</span>
          </div>
          <div style="display:flex;justify-content:flex-start;align-items:center;">
            <img src="https://img.zhujiaxian.com/2025/12/aeda23404c394181bcccbc1dc34dac6c.png" style="width: 16.9px;height:16px;margin-right: 5px;" />
            <span style="font-size: 10px;color:#FFD1D1;">售后无忧</span>
          </div>
        </div>
      </div>
      <!-- 轮播图 -->
      <div
        style="
          position: relative;
          background-image: url('https://img.zhujiaxian.com/2026/01/d0a60a43bfb543b298626fec2f57a04c.png');
          background-size: cover;
          padding-top: 10px;
        "
      >
        <SwiperCom :banner="banner"></SwiperCom>   
      </div>
      <!-- <Grid :categoryinfoList="categoryinfoList"></Grid> -->
        <div style="background: aliceblue;margin: 10px;border-radius: 12px;padding: 10px;">
        <div style="display: flex;flex-wrap: wrap;" :class="{ 'five-columns': result.h5 === 10, 'three-columns': result.h5 === 13 }">
        <div :style="{width: '25%', textAlign: 'center', padding: '5px', boxSizing: 'border-box'}" v-for="item in categoryinfoList" :key="item.id" :class="item.categoryId == 284 ?'a':'b'" @click="btn(item.categoryId)">
          <img :style="{height: result.h5 === 13 ? '58px' : '50px'}"  :src="item.icon" alt="">
          <p :style="{fontSize: '14px', marginTop: result.h5 === 13 ? '0px' : '1px', marginBottom: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',}" >{{item.categoryName}}</p>
        </div>
      </div>
    </div>
    <!-- 横向图片 -->
    <div style="margin: 0px 10px;">
      <div class="hengfu" @click="tozhenping('圳品')" data-categoryName="圳品">
        <img src="https://img.zhujiaxian.com/2026/03/4d1df8c79f814dcdbbdcc71bfce86bd6.jpg" class="imgU" style="margin-top: 0px;border-radius: 6px;width: 100%;">
      </div>
    </div>
    <div style="margin: 0px 10px;">
      <div class="hengfu" @click="toguangzhou('44')" data-categoryName="帮扶专区-广东馆">
        <img src="https://img.zhujiaxian.com/2025/12/b37e23db9a33487791bef622c850b0a0.png" class="imgU" style="margin-top: 0px;width: 100%;">
      </div>
    </div>
    <div style="margin: 0px 10px;">
      <div class="hengfu" @click="toguangzhou('45')" data-categoryName="帮扶专区-广西馆">
        <img src="https://img.zhujiaxian.com/2025/12/db316c0a39664d589651c86e0e357ea3.png" class="imgU" style="margin-top: 0px;width: 100%;">
      </div>
    </div>
    <div style="margin: 0px 10px;">
      <div class="hengfu" @click="toguangzhou('65')" data-categoryName="帮扶专区-新疆馆">
        <img src="https://img.zhujiaxian.com/2025/12/4365e5f4e9484cb29e9822642c809477.png" class="imgU" style="margin-top: 0px;width: 100%;">
      </div>
    </div>
    <div style="margin: 0px 10px;">
      <div class="hengfu" @click="toguangzhou('54')" data-categoryName="帮扶专区-西藏馆">
        <img src="https://img.zhujiaxian.com/2026/01/e80766f44c5e4692b54cedda1d87e1a8.png" class="imgU" style="margin-top: 0px;width: 100%;">
      </div>
    </div>
    <div style="margin: 0px 10px;">
      <div class="hengfu" @click="toIndexImgContent1" data-link="/pages/Zone832/Zone832" data-isspecialarea="2" data-categoryName="绿色有机地标">
        <img src="https://img.zhujiaxian.com/2025/12/4c38585a86df419e99fe8a7ba339d5fe.png" class="imgU" style="margin-top: 0px;width: 100%;">
      </div>
    </div>
    <!-- 折扣专区 -->
    <div class="discount-section">
      <div class="goods-list style-3" style='border-radius: 8px;background-color: #F85B5B;'>
        <div style="margin: 10px 0px;">
          <div @click="toPagetype(12)" style="padding: 5px 10px;padding-top: 10px;background-image: url('https://img.zhujiaxian.com/2025/12/e8d16b7e787542549d62db02d5cc3ad2.png');background-size: cover;height: 62px;position: relative;">
          </div>
          <div class="discount-list">
            <div v-for="item in type1" :key="item.id" @click="clickFn(item.skipId)">
              <img class="tehuiimg" :src="item.imgUrl" alt="">
              <div style="font-family:'DIN';font-weight: 500;font-size: 14px;color: #0D1401;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden;margin-bottom: 10px;margin-top: 10px;">
                <span>{{item.prodName}}</span>
              </div>
              <div>
                <div style="color:#E0370F;font-size:15px;display:flex;justify-content:space-between;align-items:center;font-family:'DIN';font-weight:700;">
                  <div class='price'>
                    <span class='symbol'>￥</span>
                    <span class='big-num'>{{parsePrice(item.price)[0]}}</span>
                    <span class='small-num'>.{{parsePrice(item.price)[1]}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 良心好米产品 -->
    <div style="border-radius: 12px;margin: 10px;padding-bottom:5px;">
      <div style="font-size: 0;">
        <img style="width: 100%;height: 7.9vh;font-size: 0px;" src="https://img.zhujiaxian.com/2025/12/d99e364a1e9b4169ab0fdd78cafe263a.png" alt="">
      </div>
      <div>
        <div>
          <!-- 良心好米产品img -->
          <div>
          </div>
          <!-- 良心好米产品商品 -->
          <div class="localColor">
            <div @click="clickFn(type3.skipId)">
              <img style="width:100%;height: 16vh;font-size: 0px;" :src="type3.streamer" alt="">
            </div>
            <div style="overflow: hidden;">
              <div class="whl-seckill-container">
                <div>
                  <div class="whl-seckill-swiper">
                    <div class="whl-seckill-swiper-item" v-for="(item, index) in type3.list" :key="index">
                      <!-- <div v-if="!item.mainHeading || !item.imgUrl"></div> -->
                      <div  style="padding:10px;text-align:center;background:#ffffff;border-radius: 12px 12px 12px 12px;" @click="clickFn(item.skipId)">
                        <div>
                          <div style="background-color:#fff;width:100px;height:100px;border-radius: 5px;margin: 0 auto;">
                            <div>
                              <div>
                                <img style="width:85px;height:85px;margin-top: 10px;" :src="item.imgUrl" alt="">
                              </div>
                            </div>
                          </div>
                          <div>
                            <div style="height:80rpx;">
                              <p style="color: #907058; display:-webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp:2;overflow: hidden;text-overflow: ellipsis;font-size: 14px;">{{item.prodName}}</p>
                            </div>
                            <div style="display: flex;align-items: baseline;justify-content: space-between;">
                              <div class='price'>
                                <span class='symbol'>￥</span>
                                <span class='big-num'>{{parsePrice(item.price)[0]}}</span>
                                <span class='small-num'>.{{parsePrice(item.price)[1]}}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <!-- 良心好米下面列 -->
      <div class="Populargoods" v-for="item in type2Second" :key="item.id" v-if="item.imgUrl">
        <div style="margin-bottom:4px;margin-top: 0px;">
          <img style="width:100%;height: 17vh;display: block;font-size: 0;" @click="clickFn(item.skipId)" :src="item.imgUrl" alt="">
        </div>
      </div>
    </div>
    <!-- 良心好米end -->
    <!-- 品质好油产品 -->
    <div style="border-radius: 12px;margin: 10px;padding-bottom:5px;">
      <div style="font-size: 0;">
        <img style="width: 100%;height: 7.9vh;font-size: 0px;" src="https://img.zhujiaxian.com/2025/12/e94c7dc668ee4a2fa2deefe04c217ba8.png" alt="">
      </div>
      <div>
        <div>
          <!-- 品质好油产品img -->
          <div>
          </div>
          <!-- 品质好油产品商品 -->
          <div class="localColor">
            <div @click="clickFn(type3Second.skipId)">
              <img style="width:100%;height: 16vh;font-size: 0px;" :src="type3Second.streamer" alt="">
            </div>
            <div style="overflow: hidden;">
              <div class="whl-seckill-container">
                <div>
                  <div class="whl-seckill-swiper">
                    <div class="whl-seckill-swiper-item" v-for="(item, index) in type3Second.list" :key="index">
                      <!-- <div v-if="!item.mainHeading || !item.imgUrl"></div> -->
                      <div  style="padding:10px;text-align:center;background:#ffffff;border-radius: 12px 12px 12px 12px;" @click="clickFn(item.skipId)">
                        <div>
                          <div style="background-color:#fff;width:100px;height:100px;border-radius: 5px;margin: 0 auto;">
                            <div>
                              <div>
                                <img style="width:85px;height:85px;margin-top: 10px;" :src="item.imgUrl" alt="">
                              </div>
                            </div>
                          </div>
                          <div>
                            <div style="height:80rpx;">
                              <p style="color: #907058; display:-webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp:2;overflow: hidden;text-overflow: ellipsis;font-size: 14px;">{{item.prodName}}</p>
                            </div>
                            <div style="display: flex;align-items: baseline;justify-content: space-between;">
                              <div class='price'>
                                <span class='symbol'>￥</span>
                                <span class='big-num'>{{parsePrice(item.price)[0]}}</span>
                                <span class='small-num'>.{{parsePrice(item.price)[1]}}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <!-- 品质好油下面列 -->
      <div class="Populargoods" v-for="item in type31Second" :key="item.id" v-if="item.imgUrl">
        <div style="margin-bottom:4px;margin-top: 0px;">
          <img style="width:100%;height: 17vh;display: block;font-size: 0;" @click="clickFn(item.skipId)" :src="item.imgUrl" alt="">
        </div>
      </div>
    </div>
    <!-- 品质好油end -->


    <!-- 休闲一刻产品 -->
    <div style="border-radius: 12px;margin: 10px;padding-bottom:5px;">
      <div style="font-size: 0;">
        <img style="width: 100%;height: 7.9vh;font-size: 0px;" src="https://img.zhujiaxian.com/2025/12/7a8d2c4d743146dc80c30c636c4aff4a.png" alt="">
      </div>
      <div>
        <div>
          <!-- 休闲一刻产品img -->
          <div>
          </div>
          <!-- 休闲一刻产品商品 -->
          <div class="localColor">
            <div @click="clickFn(type3_.skipId)">
              <img style="width:100%;height: 16vh;font-size: 0px;" :src="type3_.streamer" alt="">
            </div>
            <div style="overflow: hidden;">
              <div class="whl-seckill-container">
                <div>
                  <div class="whl-seckill-swiper">
                    <div class="whl-seckill-swiper-item" v-for="(item, index) in type3_.list" :key="index">
                      <!-- <div v-if="!item.mainHeading || !item.imgUrl"></div> -->
                      <div  style="padding:10px;text-align:center;background:#ffffff;border-radius: 12px 12px 12px 12px;" @click="clickFn(item.skipId)">
                        <div>
                          <div style="background-color:#fff;width:100px;height:100px;border-radius: 5px;margin: 0 auto;">
                            <div>
                              <div>
                                <img style="width:85px;height:85px;margin-top: 10px;" :src="item.imgUrl" alt="">
                              </div>
                            </div>
                          </div>
                          <div>
                            <div style="height:80rpx;">
                              <p style="color: #907058; display:-webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp:2;overflow: hidden;text-overflow: ellipsis;font-size: 14px;">{{item.prodName}}</p>
                            </div>
                            <div style="display: flex;align-items: baseline;justify-content: space-between;">
                              <div class='price'>
                                <span class='symbol'>￥</span>
                                <span class='big-num'>{{parsePrice(item.price)[0]}}</span>
                                <span class='small-num'>.{{parsePrice(item.price)[1]}}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <!-- 休闲一刻下面列 -->
      <div class="Populargoods" v-for="item in type3_Second" :key="item.id" v-if="item.imgUrl">
        <div style="margin-bottom:4px;margin-top: 0px;">
          <img style="width:100%;height: 17vh;display: block;font-size: 0;" @click="clickFn(item.skipId)" :src="item.imgUrl" alt="">
        </div>
      </div>
    </div>
    <!-- 休闲一刻end -->



      <!-- 果香四溢产品 -->
    <div style="border-radius: 12px;margin: 10px;padding-bottom:5px;">
      <div style="font-size: 0;">
        <img style="width: 100%;height: 7.9vh;font-size: 0px;" src="https://img.zhujiaxian.com/2025/12/9b83bed992df4e13b4d75fe2f4d74b04.png" alt="">
      </div>
      <div>
        <div>
          <!-- 果香四溢产品img -->
          <div>
          </div>
          <!-- 果香四溢产品商品 -->
          <div class="localColor">
            <div @click="clickFn(type4_.skipId)">
              <img style="width:100%;height: 16vh;font-size: 0px;" :src="type4_.streamer" alt="">
            </div>
            <div style="overflow: hidden;">
              <div class="whl-seckill-container">
                <div>
                  <div class="whl-seckill-swiper">
                    <div class="whl-seckill-swiper-item" v-for="(item, index) in type4_.list" :key="index">
                      <!-- <div v-if="!item.mainHeading || !item.imgUrl"></div> -->
                      <div  style="padding:10px;text-align:center;background:#ffffff;border-radius: 12px 12px 12px 12px;" @click="clickFn(item.skipId)">
                        <div>
                          <div style="background-color:#fff;width:100px;height:100px;border-radius: 5px;margin: 0 auto;">
                            <div>
                              <div>
                                <img style="width:85px;height:85px;margin-top: 10px;" :src="item.imgUrl" alt="">
                              </div>
                            </div>
                          </div>
                          <div>
                            <div style="height:80rpx;">
                              <p style="color: #907058; display:-webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp:2;overflow: hidden;text-overflow: ellipsis;font-size: 14px;">{{item.prodName}}</p>
                            </div>
                            <div style="display: flex;align-items: baseline;justify-content: space-between;">
                              <div class='price'>
                                <span class='symbol'>￥</span>
                                <span class='big-num'>{{parsePrice(item.price)[0]}}</span>
                                <span class='small-num'>.{{parsePrice(item.price)[1]}}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <!-- 果香四溢下面列 -->
      <div class="Populargoods" v-for="item in type4_Second" :key="item.id" v-if="item.imgUrl">
        <div style="margin-bottom:4px;margin-top: 0px;">
          <img style="width:100%;height: 17vh;display: block;font-size: 0;" @click="clickFn(item.skipId)" :src="item.imgUrl" alt="">
        </div>
      </div>
    </div>
    <!-- 果香四溢end -->




    
      <!-- 浓郁乳香产品 -->
    <div style="border-radius: 12px;margin: 10px;padding-bottom:5px;">
      <div style="font-size: 0;">
        <img style="width: 100%;height: 7.9vh;font-size: 0px;" src="https://img.zhujiaxian.com/2025/12/73682fe757cf49c894ccaca83ede544d.png" alt="">
      </div>
      <div>
        <div>
          <!-- 浓郁乳香产品img -->
          <div>
          </div>
          <!-- 浓郁乳香产品商品 -->
          <div class="localColor">
            <div @click="clickFn(type5_.skipId)">
              <img style="width:100%;height: 16vh;font-size: 0px;" :src="type5_.streamer" alt="">
            </div>
            <div style="overflow: hidden;">
              <div class="whl-seckill-container">
                <div>
                  <div class="whl-seckill-swiper">
                    <div class="whl-seckill-swiper-item" v-for="(item, index) in type5_.list" :key="index">
                      <!-- <div v-if="!item.mainHeading || !item.imgUrl"></div> -->
                      <div  style="padding:10px;text-align:center;background:#ffffff;border-radius: 12px 12px 12px 12px;" @click="clickFn(item.skipId)">
                        <div>
                          <div style="background-color:#fff;width:100px;height:100px;border-radius: 5px;margin: 0 auto;">
                            <div>
                              <div>
                                <img style="width:85px;height:85px;margin-top: 10px;" :src="item.imgUrl" alt="">
                              </div>
                            </div>
                          </div>
                          <div>
                            <div style="height:80rpx;">
                              <p style="color: #907058; display:-webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp:2;overflow: hidden;text-overflow: ellipsis;font-size: 14px;">{{item.prodName}}</p>
                            </div>
                            <div style="display: flex;align-items: baseline;justify-content: space-between;">
                              <div class='price'>
                                <span class='symbol'>￥</span>
                                <span class='big-num'>{{parsePrice(item.price)[0]}}</span>
                                <span class='small-num'>.{{parsePrice(item.price)[1]}}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <!-- 浓郁乳香下面列 -->
      <div class="Populargoods" v-for="item in type5_Second" :key="item.id" v-if="item.imgUrl">
        <div style="margin-bottom:4px;margin-top: 0px;">
          <img style="width:100%;height: 17vh;display: block;font-size: 0;" @click="clickFn(item.skipId)" :src="item.imgUrl" alt="">
        </div>
      </div>
    </div>
    <!-- 浓郁乳香end -->



      <!-- 品质生活产品 -->
    <div style="border-radius: 12px;margin: 10px;padding-bottom:5px;">
      <div style="font-size: 0;">
        <img style="width: 100%;height: 7.9vh;font-size: 0px;" src="https://img.zhujiaxian.com/2025/12/06910c4379c143cd90032798174d501e.png" alt="">
      </div>
      <div>
        <div>
          <!-- 品质生活产品img -->
          <div>
          </div>
          <!-- 品质生活产品商品 -->
          <div class="localColor">
            <div @click="clickFn(type6_.skipId)">
              <img style="width:100%;height: 16vh;font-size: 0px;" :src="type6_.streamer" alt="">
            </div>
            <div style="overflow: hidden;">
              <div class="whl-seckill-container">
                <div>
                  <div class="whl-seckill-swiper">
                    <div class="whl-seckill-swiper-item" v-for="(item, index) in type6_.list" :key="index">
                      <!-- <div v-if="!item.mainHeading || !item.imgUrl"></div> -->
                      <div  style="padding:10px;text-align:center;background:#ffffff;border-radius: 12px 12px 12px 12px;" @click="clickFn(item.skipId)">
                        <div>
                          <div style="background-color:#fff;width:100px;height:100px;border-radius: 5px;margin: 0 auto;">
                            <div>
                              <div>
                                <img style="width:85px;height:85px;margin-top: 10px;" :src="item.imgUrl" alt="">
                              </div>
                            </div>
                          </div>
                          <div>
                            <div style="height:80rpx;">
                              <p style="color: #907058; display:-webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp:2;overflow: hidden;text-overflow: ellipsis;font-size: 14px;">{{item.prodName}}</p>
                            </div>
                            <div style="display: flex;align-items: baseline;justify-content: space-between;">
                              <div class='price'>
                                <span class='symbol'>￥</span>
                                <span class='big-num'>{{parsePrice(item.price)[0]}}</span>
                                <span class='small-num'>.{{parsePrice(item.price)[1]}}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <!-- 品质生活下面列 -->
      <div class="Populargoods" v-for="item in type6_Second" :key="item.id" v-if="item.imgUrl">
        <div style="margin-bottom:4px;margin-top: 0px;">
          <img style="width:100%;height: 17vh;display: block;font-size: 0;" @click="clickFn(item.skipId)" :src="item.imgUrl" alt="">
        </div>
      </div>
    </div>
    <!-- 品质生活end -->
     <!-- 山珍干货 -->
    <div style="border-radius: 12px;padding-top: 10px;margin: 10px;">
      <div @click="clickFn(type4_.skipId)" style="display:flex;justify-content:space-between;align-items:center;font-size: 0;">
        <img style="width: 100%;height: 7.9vh;font-size: 0px;" src="https://img.zhujiaxian.com/2025/12/29596e34c4dd4e398636eb3c6bc64372.png" alt="">
      </div>
      <div>
        <div class="assist">
          <div>
            <div style="display:flex;justify-content:space-evenly;flex-wrap: wrap;">
              <div style="text-align:center;margin-top:10px;width:32%;background:#ffffff;padding:10px;border-radius: 12px;box-sizing: border-box;" v-for="item in type4.list" :key="item.id" @click="clickFn(item.skipId)">
                <img :src="item.imgUrl" style="width: 100%;height: 100px;" alt="">
                <div style="display: -webkit-box;-webkit-box-orient: vertical;overflow: hidden;-webkit-line-clamp: 2;color:#767676;font-size: 14px;">
                  {{item.prodName}}
                </div>
                <div style="display: flex;align-items: baseline;justify-content: space-between;">
                  <div class='price'>
                    <span class='symbol'>￥</span>
                    <span class='big-num'>{{parsePrice(item.price)[0]}}</span>
                    <span class='small-num'>.{{parsePrice(item.price)[1]}}</span>
                  </div>
                  <div>
                    <div class="original">
                      <span class="original-price">￥{{parsePrice(item.oriPrice)[0]}}.{{parsePrice(item.oriPrice)[1]}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 山珍干货end -->
      <div>
        <div class="week-product">
          <div>
            <div style="margin-top: 20px;">
              <img style="width: 100%;"  src="https://img.zhujiaxian.com/2025/11/081f7543add0462682a939cf73157068.png" alt="">
            </div>
            <div class="hotsale-item-cont">
                <div class="prod-items"  v-for="item in taglist" :key="item.id" @click="clickFn(item.prodId)">
                    <div class="hot-imagecont">
                        <img class="hotsaleimg"  :src="item.pic" alt="">
                    </div>
                    <div class="hot-text">
                        <div class="hotprod-text">{{ item.prodName }}</div>
                        <div class="prod-text-info">
                            <div class="price">
                                 <div style="display: flex; align-items: center;">                                    <template v-if="result.h5 === 9 || result.h5 === 13">                                        <img src="https://img.zhujiaxian.com/2025/09/c5cc377d7c4c44f489ddc1130c867d08.png" alt="积分" style="width: 16px; height: 16px; margin-right: 4px;"/></template>                                    <span v-else class="symbol">￥</span>                                </div>
                                <span class="big-num">{{ Math.floor(item.price) }}</span>
                                <span class="small-num">.{{ ((item.price % 1) * 100).toFixed(0).padStart(2, '0') }}</span>
                            </div>
                            <div class="prices" v-if="result.h5 !== 16">
                                <template v-if="result.h5 === 9">
                                    <img src="https://img.zhujiaxian.com/2025/09/c5cc377d7c4c44f489ddc1130c867d08.png" alt="积分" style="width: 16px; height: 16px; margin-right: 4px;"/>
                                </template>
                                <span v-else class="symbols">￥</span>
                                <span class="ori-price">{{ Number(item.oriPrice).toFixed(2) }}</span>
                            </div>
                            <div v-else>

                            </div>
                        </div>
                        <!-- <div style="margin-left:5px; color: #999;font-size: 12px;">
                             销量：{{item.soldNum === null ?0 :item.soldNum}}
                        </div> -->
                    </div>
                </div>
                <!-- 加载中提示 -->
                <div v-if="loading" class="loading-wrapper">
                  <img src="https://img.zhujiaxian.com/2025/05/21f52dbb86f247098f3b3add676a775b.gif" alt="加载中" class="loading-gif">
                </div>
            </div>
        </div>
        </div>
      </div>
    </main>
    <!-- 温馨提示弹窗 -->
    <van-dialog 
      v-model="dialogshow" 
      title="注意事项"  
      :confirm-button-text="texts" 
      :before-close="onBeforeClose" 
      :confirm-button-color="colorStatus" 
      :show-confirm-button="status"> 
      <p style="margin: 10px 12px 0px 14px;font-size: 15px;color: red;">1.信息填写务必准确，方便后期联系；</p> 
      <p style="margin: 10px 12px 0px 14px;font-size: 15px;color: red;">2.每人有800积分，可选择不同的套餐，积分用完为止。完成选择后，相应套餐产品将无法修改，请慎重选择；</p> 
      <p style="margin: 10px 12px 0px 14px;font-size: 15px;color: red;">3.收件人联系方式、地址等信息务必准确，避免出现后期联系不上的情况；</p> 
      <p style="margin: 10px 12px 0px 14px;font-size: 15px;color: red;">4.选货截止时间为2025年9月29日（周一）18:00，请各位老干部尽快完成选品。</p>  
    </van-dialog>
    
    <!-- 客服在线咨询 -->
    <!-- <div class="ymwl-form" id="ymwl-kefu" style="position: fixed; right: 20px; bottom: 100px; z-index: 9999; width: 60px; height: 60px; background-color: transparent;">
      <form action="https://kefu.zhujiaxian.com/index/index/home?theme=05202d&visiter_id=&visiter_name=&avatar=&business_id=1&groupid=0" method="post" target="_blank" style="width: 100%; height: 100%; margin: 0; padding: 0;">
        <input type="hidden" name="product" value="">
        <button type="submit" style="width: 100%; height: 100%; border: none; background: url('https://img.zhujiaxian.com/2023/03/dfe3927c454b4f1dae43d1e86024c3cf.png') no-repeat center center; background-size: contain; cursor: pointer; padding: 0; margin: 0;">
          <span style="display: none;">在线咨询</span>
        </button>
      </form>
    </div> -->
  </div>
</template>

<script>
// 导入轮播图组件
import SwiperCom from "@/components/SwiperCom";
import {
  getIndexList,
  getShowWindow,
  getindexImgs,
  getcategoryInfo,
  getProdTagList,
  getprodListByTagId,
  GetFenleiDataApi
} from "@/https/http.js";
// 引入 grid  居家-志趣组件
import Grid from "@/views/home/Grid";
// 引入support 组件-品牌制造商直供
import Support from "@/views/home/Support";
import Weekproduct from "@/views/home/Weekproduct";
import TopicBox from "@/views/home/TopicBox";
import Top from "@/views/home/Top";
// 导入URL工具函数
import { getActivityIdFromRoute } from "@/utils/urlUtil"
import { Dialog } from 'vant';
export default {
  name: "home",
  components: {
    [Dialog.Component]: Dialog.Component
  },
  data() {
    return {
      loading: false, // 添加 loading 状态
      isLoading: true,
      value: "",
      dialogshow: false,
      texts: '3秒后确定',
      colorStatus: '#1989fa',
      status: true,
      countdown: 3,
      timer: null,
      swipeas: [
        {
          imgUrl:
            "http://img.zhujiaxian.com/2023/03/37d23168d5f84c22a34d3d86e1789c7b.png",
          link: "/pages/Groupbuying/Groupbuying",
          relation: null,
          seq: 3,
          type: 2,
          text: "工会团购",
        },
        {
          imgUrl:
            "https://img.zhujiaxian.com/2024/02/01cfd47f7c9d4424a2f42e938874559e.png",
          link: "/pages/Zone832/Zone832",
          relation: null,
          seq: 3,
          type: 2,
          isSpecialArea: 99,
          text: "食堂配送",
        },
        {
          imgUrl:
            "http://img.zhujiaxian.com/2023/03/62919ae190074706b9c7d36ebe7bc135.png",
          link: "/pages/Help/Help",
          relation: null,
          seq: 3,
          type: 2,
          text: "对口帮扶",
        },
        {
          imgUrl:
            "http://img.zhujiaxian.com/2023/03/2229da12035847e0b9c687821affc5c0.png",
          link: "/pages/Zone832/Zone832",
          relation: null,
          seq: 3,
          type: 2,
          isSpecialArea: 2,
          text: "绿色有机",
        },
        {
          imgUrl:
            "http://img.zhujiaxian.com/2023/03/481546ba9c3645ec9d17d9f1458031cc.png",
          link: "/pages/Recommend/Recommend",
          relation: null,
          seq: 3,
          type: 2,
          text: "新品专区",
        },
      ],
      result: {
      size: 14,
      sort: 0,
      pages: 0,
      current: 1,
      orderBy: 0
    },
      banner: [], //轮播图
      channel: [], //居家-志趣数据
      // 活动ID为10时的分类列表
      activity10CategoryList: [
        {
          categoryId: 4744,
          categoryName: "大米",
          icon: "https://img.zhujiaxian.com/2025/09/58068957167d407ea46b4b68b500c079.png"
        },
        {
          categoryId: 4745,
          categoryName: "食用油",
          icon: "https://img.zhujiaxian.com/2025/09/431071cfef2a4adf8a2abba618a6c340.png"
        },
        {
          categoryId: 4746,
          categoryName: "杂粮",
          icon: "https://img.zhujiaxian.com/2025/09/0e7f9443a680422ca21999665b886b9c.png"
        },{
          categoryId: 4747,
          categoryName: "面/粉",
          icon: "https://img.zhujiaxian.com/2025/09/ad01288986584d19850418a14145c1cd.png"
        },{
          categoryId: 4748,
          categoryName: "南北干货",
          icon: "https://img.zhujiaxian.com/2025/09/fb1d9598c250423cbfb691d066a73784.png"
        },{
          categoryId: 4749,
          categoryName: "牛奶饮品",
          icon: "https://img.zhujiaxian.com/2025/09/cb3643683fc64881b0c9a4fa191748bf.png"
        },{
          categoryId: 4750,
          categoryName: "生鲜冻品",
          icon: "https://img.zhujiaxian.com/2025/09/0bcdaf8d0fe44f63b781d6837231fafe.png"
        },
        {
          categoryId: 4751,
          categoryName: "休闲食品",
          icon: "https://img.zhujiaxian.com/2025/09/06ad4f4ee15743f38510640ec2950b0f.png"
        },
        {
          categoryId: 4752,
          categoryName: "冲调滋补",
          icon: "https://img.zhujiaxian.com/2025/09/eca3bc1729a64db9956f132170879611.png"
        },
        {
          categoryId: 4753,
          categoryName: "日化百货",
          icon: "https://img.zhujiaxian.com/2024/10/5cb76b47c63f4b8bb4794f5564904b24.png"
        },
      ],
      // 默认分类列表（活动ID为8或其他情况）
      defaultCategoryList: [
        {
          categoryId: 284,
          categoryName: "粮油副食",
          icon: "https://img.zhujiaxian.com/2024/10/795bbf56222d45148e97fa90131ba1d9.png"
        },
        {
          categoryId: 352,
          categoryName: "休闲食品",
          icon: "https://img.zhujiaxian.com/2024/10/4235cdb9b77a45e6bf06c007a57d8561.png"
        },
        {
          categoryId: 550,
          categoryName: "南北干货",
          icon: "https://img.zhujiaxian.com/2024/10/9d6006bf917946429cb41d200a2b4513.png"
        },{
          categoryId: 406,
          categoryName: "生鲜果蔬",
          icon: "https://img.zhujiaxian.com/2024/10/2764ea3e3f3e4a66bc322fe2d8923c1a.png"
        },{
          categoryId: 490,
          categoryName: "家居生活",
          icon: "https://img.zhujiaxian.com/2024/10/88706594dc0249d1a3399294c5f0be84.png"
        },{
          categoryId: 575,
          categoryName: "奶制品",
          icon: "https://img.zhujiaxian.com/2024/10/8bec755005a24609b1fcb0e0897346c6.png"
        },{
          categoryId: 129,
          categoryName: "酒水茶饮",
          icon: "https://img.zhujiaxian.com/2024/10/6e93c8d1872b4eac8b6c954258f3a530.png"
        },
        {
          categoryId: 545,
          categoryName: "套餐精选",
          icon: "https://img.zhujiaxian.com/2024/10/5cb76b47c63f4b8bb4794f5564904b24.png"
        },
      ],
      // 活动ID为13时的分类列表 - 东西优选消费帮扶兑换专区
      activity13CategoryList: [
        {
          categoryId: 4760,
          categoryName: "粮油副食",
          icon: "https://img.zhujiaxian.com/2024/10/795bbf56222d45148e97fa90131ba1d9.png"
        },
        {
          categoryId: 4762,
          categoryName: "零食茶饮",
          icon: "https://img.zhujiaxian.com/2024/10/4235cdb9b77a45e6bf06c007a57d8561.png"
        },
        {
          categoryId: 4761,
          categoryName: "南北干货",
          icon: "https://img.zhujiaxian.com/2024/10/9d6006bf917946429cb41d200a2b4513.png"
        },{
          categoryId: 4763,
          categoryName: "生鲜水果",
          icon: "https://img.zhujiaxian.com/2024/10/2764ea3e3f3e4a66bc322fe2d8923c1a.png"
        },{
          categoryId: 4764,
          categoryName: "个护日化",
          icon: "https://img.zhujiaxian.com/2024/10/88706594dc0249d1a3399294c5f0be84.png"
        },{
          categoryId: 4765,
          categoryName: "套餐精选",
          icon: "https://img.zhujiaxian.com/2024/10/5cb76b47c63f4b8bb4794f5564904b24.png"
        },
      ],
      activity16CategoryList: [
        {
          categoryId: 4769,
          categoryName: "大米",
          icon: "https://img.zhujiaxian.com/2026/01/29745d554bb14df5bb3a0ac16f574fd0.png"
        },
        {
          categoryId: 4770,
          categoryName: "食用油",
          icon: "https://img.zhujiaxian.com/2026/01/ae532280d55c4affbeddfdfad2540cdb.png"
        },{
          categoryId: 4771,
          categoryName: "奶制品",
          icon: "https://img.zhujiaxian.com/2026/01/17b338a6504847f98b60f4261d791755.png"
        },{
          categoryId: 4772,
          categoryName: "菌菇干货",
          icon: "https://img.zhujiaxian.com/2026/01/db564df75e0447e2b42cfa1b2a01b524.png"
        },{
          categoryId: 4773,
          categoryName: "海产干货",
          icon: "https://img.zhujiaxian.com/2026/01/c98803d1de7d402682ca4800ae2eb904.png"
        },{
          categoryId: 4774,
          categoryName: "面粉面食",
          icon: "https://img.zhujiaxian.com/2026/01/7780895631ad43698afd33b3d3f78348.png"
        },
        {
          categoryId: 4775,
          categoryName: "五谷杂粮",
          icon: "https://img.zhujiaxian.com/2026/01/627923be9acc422189861fe8e7ed8974.png"
        },
        {
          categoryId: 4776,
          categoryName: "休闲零食",
          icon: "https://img.zhujiaxian.com/2026/01/2e87db2d121646b3a4feba2c7f444701.png"
        }
      ],
      // 当前使用的分类列表
      categoryinfoList: [],
      brandList: [], // 品牌制造商数据
      newGoodsList: [], // 热销好品
      ProdRecommend:[],//好物推荐
      hotGoodsList: [], // 人气推荐
      topicList: [], // 专题精选
      taglist: [], //
      categoryList: [], //产品列表
      type5:[],//大牌优选
      type1T:[],//特惠专区
      // 默认折扣专区产品数据
      type1: [
        {
          id: 1,
          skipId: 57667,
          imgUrl: "https://img.zhujiaxian.com/2026/02/6fdd5f03ed904911a8c33bba47dee81b.jpg",
          prodName: "【驻家鲜】鱿鱼干 250g/500g 蓝色包装 特惠",
          price: 141.60
        },
        {
          id: 2,
          skipId: 64030,
          imgUrl: "https://img.zhujiaxian.com/2026/02/8c2c6778231a498ba31335ee79635292.jpg",
          prodName: "富崎乐原切肉干套餐组合 272g/份 1份装",
          price: 108.00
        },
        {
          id: 3,
          skipId: 67917,
          imgUrl: "https://img.zhujiaxian.com/2026/04/5613f7ba0177400fb195debcf9c3069a.png",
          prodName: "【万壮】甄选品质潮汕牛筋丸 柠檬猪肉丸 墨鱼丸 干贝猪肉丸汕头小吃特产",
          price: 131.10
        },
        {
          id: 4,
          skipId: 62708,
          imgUrl: "https://img.zhujiaxian.com/2025/12/04b9e818770e43ee838646b674d7e1d4.jpg",
          prodName: "皇上皇好事齐来腊肉腊肠礼袋800g",
          price: 125.00
        }
      ],
      // 良心好米产品数据
      type3: {
        windowsName: "良心好米",
        skipId: 57721,
        streamer: "https://img.zhujiaxian.com/2025/12/c1747247846f4d93b765d6a699319968.png",
        list: [
          {
            id: 1,
            skipId: 62895,
            imgUrl: "https://img.zhujiaxian.com/2025/12/b538383e4b9f4936ae04deccbee78a64.jpg",
            prodName: "太粮（新版）曼哈浓香莲花香米4kg",
            price: 59.00
          },
          {
            id: 2,
            skipId: 61013,
            imgUrl: "https://img.zhujiaxian.com/2025/12/ef83eae56c374092b24003cf325a9a9b.jpg",
            prodName: "【山臻U品】有机八宝米 350g*3袋",
            price: 47.40
          },
          {
            id: 3,
            skipId: 60928,
            imgUrl: "https://img.zhujiaxian.com/2025/12/c8e8967c370949f8bff1c23be7849336.jpg",
            prodName: "【江京】江京马坝油粘米5kg 大米",
            price: 79.90
          },
          {
            id: 4,
            skipId: 63205,
            imgUrl: "https://img.zhujiaxian.com/2025/12/bf83291f05334fc4af19b94cf92591c5.jpg",
            prodName: "绿次方有机七色糙米1kg",
            price: 38.00
          },
          {
            id: 5,
            skipId: 63351,
            imgUrl: "https://img.zhujiaxian.com/2025/12/080e405afa094f9eb5bbee01caa32646.png",
            prodName: "邻家饭香五常大米5kg",
            price: 89.00
          }
        ]
      },
      // 良心好米下面列数据
      type2Second: [
        {
          id: 1,
          skipId: 57200,
          imgUrl: "https://img.zhujiaxian.com/2025/12/19819568cef04ca1853d6ebd642dc4e4.png"
        },
        {
          id: 2,
          skipId: 57299,
          imgUrl: "https://img.zhujiaxian.com/2025/12/1254cf2cd2564d8f87f566cdec863f9e.png"
        },
        {
          id: 3,
          skipId: 60929,
          imgUrl: "https://img.zhujiaxian.com/2025/12/af2f15ddcfb349d2806dcf769e0a3fdd.png"
        }
      ],
       // 品质好油产品数据
      type3Second: {
        windowsName: "品质好油",
        skipId: 56531,
        streamer: "https://img.zhujiaxian.com/2025/12/5c592889b764434c96de90d0f28c5400.png",
        list: [
          {
            id: 1,
            skipId: 62825,
            imgUrl: "https://img.zhujiaxian.com/2025/12/90f73c7a1afd4e66b1187ac827bae1e2.jpg",
            prodName: "福临门 金阙谣花生油5L",
            price: 189.00
          },
          {
            id: 2,
            skipId: 62466,
            imgUrl: "https://img.zhujiaxian.com/2025/12/a2386708d50e464abb2b791c0f1426c6.jpg",
            prodName: "鲁王 压榨玉米油900ml*2",
            price: 62.60
          },
          {
            id: 3,
            skipId: 57165,
            imgUrl: "https://img.zhujiaxian.com/2026/03/2d774d50ed134a2fac24659e0447b212.png",
            prodName: "【中义】四川阆中市 中义特级初榨橄榄油250ml礼盒(S175) 年货",
            price: 133.00
          },
          {
            id: 4,
            skipId: 56340,
            imgUrl: "https://img.zhujiaxian.com/2025/12/bce2beb523f2462da9a5bb3b41dcdc4a.jpg",
            prodName: "【阿诚】芝麻香油500ml*2 [荐]",
            price: 62.70
          },
          {
            id: 5,
            skipId: 62980,
            imgUrl: "https://img.zhujiaxian.com/2026/02/38f54e686fc2439abb5a6b86b2af6eca.jpg",
            prodName: "润心 有机山茶油500ml*2礼盒",
            price: 139.90
          }
        ]
      },
      // 品质好油下面列数据
      type31Second: [
        {
          id: 1,
          skipId: 59178,
          imgUrl: "https://img.zhujiaxian.com/2025/12/15b3f7d6df7f49a0bf826992fe35b22d.png"
        },
        {
          id: 2,
          skipId: 56608,
          imgUrl: "https://img.zhujiaxian.com/2025/12/c445e9cc3a104eaeae479cb4b78d1181.jpg"
        },
        {
          id: 3,
          skipId: 56572,
          imgUrl: "https://img.zhujiaxian.com/2025/12/448d9590aa66469cb2254c7ede453e8a.jpg"
        }
      ],
      // 休闲一刻产品数据
      type3_: {
        windowsName: "休闲一刻",
        skipId: 56531,
        streamer: "https://img.zhujiaxian.com/2025/12/869f6cb77392468ea5705fc257e08555.png",
        list: [
          {
            id: 1,
            skipId: 63808,
            imgUrl: "https://img.zhujiaxian.com/2026/02/3ad25187de144ec88c9dd91635ab6535.png",
            prodName: "【源中源】鲜烤肉干 53g*1袋 多种规格",
            price: 8.50
          },
          {
            id: 2,
            skipId: 60989,
            imgUrl: "https://img.zhujiaxian.com/2026/02/18e017db1f7b426591fa0343073cb3b3.jpg",
            prodName: "【雅觅】木耳生态桃酥 270g",
            price: 18.90
          },
          {
            id: 3,
            skipId: 67329,
            imgUrl: "https://img.zhujiaxian.com/2026/04/8ed3921bc8df4fd39a39ff69bb4a73c1.jpg",
            prodName: "【麦轩】非遗粤式酥饼礼盒422.5g 圳品",
            price: 93.10
          },
          {
            id: 4,
            skipId: 68058,
            imgUrl: "https://img.zhujiaxian.com/2026/04/f06e114bddd841d4af7df003fc7f1609.jpg",
            prodName: "【千优谷】千优谷刺梨蜜饯140克/袋",
            price: 28.30
          },
          {
            id: 5,
            skipId: 59037,
            imgUrl: "https://img.zhujiaxian.com/2026/02/206ad2408fc144c69f19a18c471668e5.jpg",
            prodName: "【冠豸美食】客家姜糖 180g/盒",
            price: 13.20
          }
        ]
      },
      // 休闲一刻下面列数据
      type3_Second: [
        {
          id: 1,
          skipId: 56322,
          imgUrl: "https://img.zhujiaxian.com/2025/12/185195802d2b4825a1c7fbbd7436c654.png"
        },
        {
          id: 2,
          skipId: 58742,
          imgUrl: "https://img.zhujiaxian.com/2025/12/5c88cd8e3351495592b295026e63323f.png"
        },
        {
          id: 3,
          skipId: 60993,
          imgUrl: "https://img.zhujiaxian.com/2025/12/d39d430008bc49b3ba81e1316033fba2.png"
        }
      ],
      // 果香四溢产品数据
      type4_: {
        windowsName: "果香四溢",
        skipId: 56531,
        streamer: "https://img.zhujiaxian.com/2026/03/3ed43c1887cc4ccea9b167a048403b78.png",
        list: [
          {
            id: 1,
            skipId: 60318,
            imgUrl: "https://img.zhujiaxian.com/2026/03/91f9149852ab456597860a3a986abff6.JPG",
            prodName: "【富灵草】钦蜜9号黄金百香果 多种规格",
            price: 52.30
          },
          {
            id: 2,
            skipId: 61026,
            imgUrl: "https://img.zhujiaxian.com/2026/02/c6fcb462422a4b12a55e288c14cf5e4d.jpg",
            prodName: "【福润咏鲜】秋月梨 新鲜水果 多种规格（顺丰发货）",
            price: 63.00
          },
          {
            id: 3,
            skipId: 65306,
            imgUrl: "https://img.zhujiaxian.com/2026/04/16f011c625e54d12876b6c9ea3c24a34.jpg",
            prodName: "【顺丰或京东】秭归夏季鲜橙5斤大果果径70mm+彩箱",
            price: 56.00
          },
          {
            id: 4,
            skipId: 63989,
            imgUrl: "https://img.zhujiaxian.com/2026/02/e19585bbc0734e0d855e3719fca533bf.jpg",
            prodName: "海南红心木瓜5斤礼盒（顺丰或京东发货）",
            price: 66.00
          },
          {
            id: 5,
            skipId: 62664,
            imgUrl: "https://img.zhujiaxian.com/2026/02/024e41146e604bee92f09b3e7ed97d5e.jpg",
            prodName: "精选河北皇冠梨4.5斤装单果250g+",
            price: 39.00
          }
        ]
      },
      // 果香四溢下面列数据
      type4_Second: [
        {
          id: 1,
          skipId: 60283,
          imgUrl: "https://img.zhujiaxian.com/2025/12/02033fd4745940238bdc0a34328cd144.png"
        },
        {
          id: 2,
          skipId: 56452,
          imgUrl: "https://img.zhujiaxian.com/2026/03/1d3c4ec22d6c4bd8b73b497a7ec10412.png"
        },
        {
          id: 3,
          skipId: 60318,
          imgUrl: "https://img.zhujiaxian.com/2026/03/980ddfc6990c4348bbe3fc16fd072b80.png"
        }
      ],
      // 浓郁乳香产品数据
      type5_: {
        windowsName: "浓郁乳香",
        skipId: 61036,
        streamer: "https://img.zhujiaxian.com/2025/12/eff27d5b9d5e442b87954e39599d7df7.png",
        list: [
          {
            id: 1,
            skipId: 67292,
            imgUrl: "https://img.zhujiaxian.com/2026/03/86ff06a4701c49d8a8085b1e085b69e7.jpg",
            prodName: "【欧亚】欧亚大理牧场高钙牛奶200g*12 圳品",
            price: 47.40
          },
          {
            id: 2,
            skipId: 60944,
            imgUrl: "https://img.zhujiaxian.com/2025/12/01ae890ce4a24f6f9856da890f822870.png",
            prodName: "【咱家小牛】 咱家小牛纯牛奶 200ml×10盒/箱",
            price:61.80
          },
          {
            id: 3,
            skipId: 60943,
            imgUrl: "https://img.zhujiaxian.com/2026/02/4d180807621a4f7f9eb627c8dc8a3f8d.jpg",
            prodName: "【金脑袋】金脑袋核桃乳 246ml×8罐/箱",
            price: 61.80
          },
          {
            id: 4,
            skipId: 67287,
            imgUrl: "https://img.zhujiaxian.com/2026/03/3a377d2fb4f14c4884844e4da280bfb6.png",
            prodName: "【欧亚】欧亚利乐草莓砖250g*16 圳品",
            price: 47.40
          },
          {
            id: 5,
            skipId: 61034,
            imgUrl: "https://img.zhujiaxian.com/2026/02/eabce51bad9540b0ba63b51cd8e45881.png",
            prodName: "【君乐宝】简醇梦幻盖风味酸奶 250g*10支",
            price: 58.90
          }
        ]
      },
      // 浓郁乳香下面列数据
      type5_Second: [
        {
          id: 1,
          skipId: 58225,
          imgUrl: "https://img.zhujiaxian.com/2025/12/6750b57c76a841d8a63292296a20faad.png"
        },
        {
          id: 2,
          skipId: 59940,
          imgUrl: "https://img.zhujiaxian.com/2025/12/f87c322b49b0445ebde437f36c8a5dc6.png"
        },
        {
          id: 3,
          skipId: 61037,
          imgUrl: "https://img.zhujiaxian.com/2026/03/7ab9cd11580c4e9d89a1a6a8111819b8.png"
        }
      ],
      // 品质生活产品数据
      type6_: {
        windowsName: "品质生活",
        skipId: 56804,
        streamer: "https://img.zhujiaxian.com/2025/12/b64590df802e44f8b43c0d3f3cc04277.png",
        list: [
          {
            id: 2,
            skipId: 203,
            imgUrl: "https://img.zhujiaxian.com/2026/03/02846a26a18c4cce9d3859cf950ac96d.jpg",
            prodName: "多芬 洗护礼包2220g-（礼袋随机）",
            price: 123.60
          },
          {
            id: 3,
            skipId: 67749,
            imgUrl: "https://img.zhujiaxian.com/2026/03/1419e7ba88dc4688b5861b5a1d10e266.jpg",
            prodName: "雕牌内衣洗衣液1kg",
            price: 29.00
          },
          {
            id: 4,
            skipId: 65835,
            imgUrl: "https://img.zhujiaxian.com/2026/03/28758b5acc8d4801bc07a72cc4b34bb3.jpg",
            prodName: "波斯丹顿（BOSTANTEN）万向轮拉杆箱20寸行李箱登机箱拉链款BJ9204020",
            price: 249.00
          },
          {
            id: 5,
            skipId: 206,
            imgUrl: "https://img.zhujiaxian.com/2025/12/e99e61cefe1a44deab7865c1992a4b92.jpg",
            prodName: "双立人 Moment 浅烧锅运输型包装20cm  ZW-C122/1017228",
            price: 99.99
          },
          {
            id: 6,
            skipId: 62584,
            imgUrl: "https://img.zhujiaxian.com/2025/12/2439ee90636a46389b8c610bee5b8a9c.jpg",
            prodName: "心相印 DT8100(电商20包)心相印茶语精选100抽三层塑装面巾纸",
            price: 48.00
          }
        ]
      },
      // 品质生活下面列数据
      type6_Second: [
        {
          id: 1,
          skipId: 62604,
          imgUrl: "https://img.zhujiaxian.com/2025/12/be54492f884d48129e6d7b0f96b1415a.png"
        },
        {
          id: 2,
          skipId: 66652,
          imgUrl: "https://img.zhujiaxian.com/2026/03/482f46360a2948cda8212df6d645ae65.png"
        },
        {
          id: 3,
          skipId: 63378,
          imgUrl: "https://img.zhujiaxian.com/2025/12/83c69f7596664b7797155bf43360bfb2.png"
        }
      ],
      // 山珍干货产品数据
      type4: {
        list: [
          {
            id: 1,
            skipId: 61022,
            imgUrl: "https://img.zhujiaxian.com/2025/12/57c6e7d1b22a4339aaa0aefc5acc82eb.jpg",
            prodName: "【山臻U品】牛肝菌 120g/袋",
            price: 128.00,
            oriPrice: 0.00
          },
          {
            id: 2,
            skipId: 57760,
            imgUrl: "https://img.zhujiaxian.com/2025/12/5d91e97e639441d0a7c714d7546f1c42.jpg",
            prodName: "【驻家鲜】白茶树菇 100g/袋 彩色包装",
            price: 38.00,
            oriPrice: 0.00
          },
          {
            id: 3,
            skipId: 59088,
            imgUrl: "https://img.zhujiaxian.com/2025/12/d618109d44bc486d9df03e6a528df8b5.jpg",
            prodName: "【驻家鲜】羊肚菌150克礼盒装 炖汤",
            price: 178.60,
            oriPrice: 0.00
          },
          {
            id: 4,
            skipId: 56279,
            imgUrl: "https://img.zhujiaxian.com/2025/12/bada9fc369e6417c9b8cd11c75c2f982.jpg",
            prodName: "【驻家鲜】花菇150g 白色包装 [荐]",
            price: 35.80,
            oriPrice: 0.00
          },
          {
            id: 5,
            skipId: 57658,
            imgUrl: "https://img.zhujiaxian.com/2025/12/dd0a12414a0643dbaa943b0608480d27.jpg",
            prodName: "【驻家鲜】鹿茸菌 200g 白色包装",
            price: 49.80,
            oriPrice: 0.00
          },
          {
            id: 6,
            skipId: 57829,
            imgUrl: "https://img.zhujiaxian.com/2025/12/a11de51b0eb644b89e3ccff860f6ae53.jpg",
            prodName: "【驻家鲜】福建竹荪50g/袋 彩色包装 大牌严选",
            price: 55.00,
            oriPrice: 0.00
          }
        ]
      },
    };
  },

  components: {
    SwiperCom,
    Grid,
    Support,
    Weekproduct,
    TopicBox,
    Top,
  },
created() {
  // 重置数据状态
  this.result.current = 1;
  this.taglist = [];
  
  // 从路由中获取活动ID
  const urlActivityId = getActivityIdFromRoute(this.$route);
  // 从全局状态获取活动ID
  const globalActivityId = this.$store.getters.getActivityId;
  
  // 如果URL中存在活动ID，优先使用URL中的活动ID
  if (urlActivityId) {
      this.result.h5 = urlActivityId;
      // 当URL中的活动ID与全局状态中的不同时，才更新全局状态
      if (urlActivityId !== globalActivityId) {
        this.$store.dispatch('updateActivityId', urlActivityId);
      }
      
      // 根据活动ID设置不同的分类列表
      if (urlActivityId === 10) {
        // 活动ID为10时使用特定的分类列表
        this.categoryinfoList = this.activity10CategoryList;
      } else if (urlActivityId === 9) {
        // 活动ID为9时不显示分类列表
        this.categoryinfoList = [];
        // 活动ID为9时显示弹窗
        setTimeout(() => {
          this.dialogshow = true;
          this.startCountdown();
        }, 1000);
      } else if (urlActivityId === 12 || urlActivityId === 14) {
        // 活动ID为12或14时使用默认分类列表
        this.categoryinfoList = this.defaultCategoryList;
      } else if (urlActivityId === 15) {
        // 活动ID为15时不显示分类列表
        this.categoryinfoList = [];
        // 活动ID为15时设置sort为2
        this.result.sort = 2;
      } else if (urlActivityId === 13) {
        // 活动ID为13时使用东西优选消费帮扶兑换专区分类列表
        this.categoryinfoList = this.activity13CategoryList;
      } else if (urlActivityId === 16) {
        // 活动ID为16时使用布吉水司元旦过节物品分类列表
        this.categoryinfoList = this.activity16CategoryList;
      } else {
        // 其他情况使用默认分类列表
        this.categoryinfoList = this.defaultCategoryList;
      }
  } else if (globalActivityId) {
      // URL中没有活动ID，但全局状态中有，使用全局状态中的活动ID
      this.result.h5 = globalActivityId;
      
      // 根据全局状态中的活动ID设置不同的分类列表
      if (globalActivityId === 10) {
        this.categoryinfoList = this.activity10CategoryList;
      } else if (globalActivityId === 9) {
        // 活动ID为9时不显示分类列表
        this.categoryinfoList = [];
      } else if (globalActivityId === 12 || globalActivityId === 14) {
        // 活动ID为12或14时使用默认分类列表
        this.categoryinfoList = this.defaultCategoryList;
      } else if (globalActivityId === 15) {
        // 活动ID为15时不显示分类列表
        this.categoryinfoList = [];
        // 活动ID为15时设置sort为2
        this.result.sort = 2;
      } else if (globalActivityId === 13) {
        // 活动ID为13时使用东西优选消费Helpers兑换专区分类列表
        this.categoryinfoList = this.activity13CategoryList;
      } else if (globalActivityId === 16) {
        // 活动ID为16时使用布吉水司元旦过节物品分类列表
        this.categoryinfoList = this.activity16CategoryList;
      } else {
        this.categoryinfoList = this.defaultCategoryList;
      }
  } else {
    // 既没有URL活动ID也没有全局活动ID时，使用默认设置
    this.result.h5 = 8;
    this.categoryinfoList = this.defaultCategoryList;
  }
  
  // if (!this.$route.meta.isBack) {
    // 如果isBack是false，表明需要获取新数据，否则就不再请求，直接使用缓存的数据
    this.GetcategoryList();
  // }
 // this.getcategory();
  // 恢复成默认的false，避免isBack一直是true，导致下次无法获取数据
  this.$route.meta.isBack = false;
  this.$eventBus.$emit('changeCount');
},
  mounted() {
    // 添加滚动监听
    window.addEventListener('scroll', this.handleScroll);
  },

  beforeDestroy() {
    // 组件销毁前移除监听器
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    // 开始倒计时
    startCountdown() {
      this.countdown = 3;
      this.texts = `${this.countdown}秒后确定`;
      this.status = false;
      
      this.timer = setInterval(() => {
        this.countdown--;
        this.texts = `${this.countdown}秒后确定`;
        
        if (this.countdown <= 0) {
          clearInterval(this.timer);
          this.texts = '确定';
          this.status = true;
        }
      }, 1000);
    },
    
    // 弹窗关闭前的回调
    onBeforeClose(action, done) {
      if (action === 'confirm') {
        done();
      } else {
        done();
      }
    },
     
     btn(id){
      this.$router.push({path: '/channel', query:{id: id}})
    },
    handleScroll() {
    // 获取滚动位置
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;

    // 当距离底部小于 50px 且不在加载状态且还有更多页面时触发加载
    if (documentHeight - (scrollTop + windowHeight) < 50 && !this.loading && this.result.current < this.result.pages) {
      this.loading = true;
      console.log("触发加载更多");
      this.result.current++;
      this.GetcategoryList();
    }
  },
    //首页橱窗
    getShowWindowList() {
      getShowWindow()
        .then((res) => {
          console.log("getShowWindowList:", res.data); // 打印标签列表
          this.topicList = res.data.type3[0].list
          this.type5 = res.data.type4[1].list;
          this.newGoodsList = res.data.type2[1].list;
          this.ProdRecommend =  res.data.type2[0].list;
          this.type1T = res.data.type1[1].list;
        })
        .catch((error) => {
          console.error("Error fetching tag list:", error);
        });
    },
  
    //获取轮播标题
    getcategory() {
        let data = {
            parentId:''
        }
        // 当activityId不等于12、14或15时，才传递h5参数
        if (this.result.h5 !== 12 && this.result.h5 !== 14 && this.result.h5 !== 15) {
            data.h5 = this.result.h5;
        }
        getcategoryInfo(data).then((res)=>{
            console.log(res);
            this.categoryinfoList = res.data
        })
    },
    //跳转商品详情页
    clickFn(id) {
            this.$router.push({ path: '/productDetail', query: { id: id } })
    },
    GetcategoryList(){
      console.log('执行了')
      // 当activityId等于12、14或15时，不传递h5参数
      let apiParams = (this.result.h5 === 12 || this.result.h5 === 14) ? 
        { ...this.result, h5: undefined } : 
        this.result;
    return GetFenleiDataApi(apiParams).then((res) => {  // 添加 return
      let list = [];
      if (res.data.current == 1) {
        res.data.records.forEach((element) => {
          list.push(element);
        });
        this.taglist = list;  // 第一页直接替换
      } else {
        this.taglist = this.taglist.concat(res.data.records);  // 其他页面追加
      }
      this.result.pages = res.data.pages;
      this.loading = false;  // 加载完成后设置 loading 为 false
    }).catch(err => {
      console.error('加载数据失败:', err);
      this.loading = false;  // 出错时也要重置 loading 状态
    });
  },
    onSearch() {},
    onCancel() {},
    // 跳转圳品页面
    tozhenping(title) {
      // 这里可以添加跳转到圳品页面的逻辑
      console.log('跳转到圳品页面', title);
      // 在跳转前移除滚动事件监听器，避免在跳转过程中触发触底加载
      window.removeEventListener('scroll', this.handleScroll);
      // 跳转到页面顶部，确保页面从顶部开始显示
      window.scrollTo(0, 0);
      this.$router.push({path: '/channel', query:{title: title}})
    },
    // 跳转到广州帮扶专区
    toguangzhou(id) {
      // 这里可以添加跳转到广州帮扶专区的逻辑
      console.log('跳转到广州帮扶专区');
      // 在跳转前移除滚动事件监听器，避免在跳转过程中触发触底加载
      window.removeEventListener('scroll', this.handleScroll);
      // 跳转到页面顶部，确保页面从顶部开始显示
      window.scrollTo(0, 0);
      this.$router.push({path: '/channel', query:{id: id}})
    },
    // 跳转到绿色有机地标
    toIndexImgContent1(event) {
      // 这里可以添加跳转到绿色有机地标的逻辑
      console.log('跳转到绿色有机地标', event);
      
      window.removeEventListener('scroll', this.handleScroll);
      // 跳转到页面顶部，确保页面从顶部开始显示
      window.scrollTo(0, 0);
      this.$router.push({path: '/Zone832'})
      
    },
    // 跳转到指定类型页面
    toPagetype(type, windowsName, skipId) {
      // 这里可以添加跳转到指定类型页面的逻辑
      console.log('跳转到类型页面:', type, windowsName, skipId);
    },
    // 跳转到产品页面
    toProdPage(prodId) {
      // 这里可以添加跳转到产品页面的逻辑
      console.log('跳转到产品页面:', prodId);
    },
    // 解析价格
    parsePrice(price) {
      const priceStr = price.toFixed(2);
      return priceStr.split('.');
    },
    //轮播图请求
    getindexImg() {
      getindexImgs().then((res) => {
        console.log(res);
        this.banner = res.data;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.home {
  padding-bottom: 100px;
  box-sizing: border-box;
  background: #FF3A35 !important;
  
}
.tehuiimg {
    width: 200rpx;
}
.goods-list.style-3 .swiper {
    display: flex;
    justify-content: space-between;
    margin: 0 10px;
    padding: 5px 0;
    overflow: hidden;
}
.van-search {
  background-color: transparent;
}
.tobu {
  display: flex;
  align-items: center;
}
.week-product {
  .mytitle {
    text-align: center;
    font-size: 16px;
    position: relative;
    span {
      width: 50%;
      height: 2px;
      background-color: #ccc;
      display: inline-block;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    h3 {
      width: 30%;
      background-color: #fff;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
  ul {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    li {
      width: 49%;
      img {
        width: 100%;
      }
      p {
        text-align: center;
        font-size: 16px;
      }
    }
  }
}

// 活动ID为10时，分类列表显示为五个一列
.five-columns {
  div {
    width: 20% !important;
  }
}

// 活动ID为13时，分类列表显示为三个一列
.three-columns {
  div {
    width: 33.33% !important;
  }
}

// 商品列表
.hotsale-item-cont {
    padding-bottom: 10px;
    background: #FF3A35 ;
}
.prod-items {
    width: 173px;
    display: inline-block;
    background: #fff;
    padding-bottom: 10px;
    border-radius: 5px;
}
.prod-items:nth-child(2n-1) {
    margin: 10px 5px 5px 10px;
}
.hot-imagecont {
    font-size: 0;
    text-align: center;
}
.hotsaleimg {
    width: 171px;
    height: 171px;
}
.hot-text {
    margin-top: 10px;
    padding: 0 5px;
}
 .hotprod-text {
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.prod-text-info {
    display: flex;
    gap: 8px;
    height: 35px;
    line-height: 35px;
    position: relative;
    font-family: Arial;
    align-items: center;
    // justify-content: space-around;
    justify-content: space-between;
}

.prices {
    font-family: 'DIN';
    display: inline-flex;
    align-items: baseline;
    color: #999;
}

.symbols {
    font-size: 12px;
}

.ori-price {
    font-size: 14px;
    text-decoration: line-through;
}
.price {
    font-family: 'DIN';
    display: inline-flex;
    align-items: baseline;
    color: #E0370F;
}
.symbol {
    font-size: 14px;
    font-weight: 700;
}
.big-num {
    font-size: 18px;
    font-weight: 700;
}
.small-num {
    font-size: 14px;
    font-weight: 600;
}
.prices {
    font-family: 'DIN';
    display: inline-flex;
    align-items: baseline;
    color: rgba(217, 0, 27, 0.5);
}
.symbols {
    font-size: 12px;
    font-weight: 700;
}
.big-nums {
    font-size: 15px;
    font-weight: 700;
}
.small-nums {
    font-size: 12px;
    font-weight: 600;
}
.prod-items .hot-text .prod-text-info .basket-img {
    width: 25px;
    height: 25px;
    position: absolute;
    right: 0;
    bottom: 4px;
    padding: 4px;
}
.loading-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: rgba(255, 255, 255, 0.8);
}

.loading-gif {
  width: 100px;
  height: 100px;
  display: inline-block;
}

/* 横向图片样式 */
.hengfu {
  position: relative;
  box-sizing: border-box;
  padding-bottom: 5px;
}

// .hengfu .imgU {
//   height: 120px;
//   width: 100%;
// }

/* 折扣专区样式 */
.discount-section {
  margin: 10px;
}

.discount-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 10px;
}

.discount-list > div {
  width: 48%;
  margin-bottom: 15px;
  background-color: #fff;
  border-radius: 8px;
  padding: 10px;
  box-sizing: border-box;
}

.discount-list .tehuiimg {
  width: 100%;
  height: auto;
  border-radius: 4px;
}

/* 良心好米产品样式 */
.localColor {
  background-color: #F7F7F7;
  // border-radius: 8px;
  padding: 10px;
}

/* 轮播图样式 */
.whl-seckill-container {
  width: 100%;
  overflow: hidden;
  border-radius: 16rpx;
  margin: 0 auto;
  margin-top: 20rpx;
  padding: 0 0 20rpx 20rpx;
  box-sizing: border-box;
}

.whl-seckill-container > div:first-child {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 32rpx;
  font-weight: bold;
}

.whl-seckill-container > div:nth-child(2) {
  width: 100%;
  height: auto;
  overflow: hidden;
}

.whl-seckill-swiper {
  display: flex;
  justify-content: flex-start;
  width: 100%;
  overflow-x: auto;
  padding-bottom: 10px;
}

.whl-seckill-swiper-item {
  // flex: 0 0 auto;
  width: 200rpx;
  margin-right: 20rpx;
}

.whl-seckill-swiper-item > div {
  width: 80%;
  height: auto;
}

/* 良心好米下面列样式 */
.Populargoods {
  margin:0px 10px;
  box-sizing: border-box;
}

/* 山珍干货样式 */
.assist {
  background-color: #F7F7F7;
  padding: 10px;
  border-radius: 8px;
}

/* 原始价格样式 */
.original {
  font-size: 12px;
  color: #bbb;
  margin-top: 15rpx;
}

.original-price {
  font-size: 12px;
  text-decoration: line-through;
  color: #bbb;
  margin-left: 10rpx;
}
</style>
